<ng-container *ngIf="cards && cards.length > 0; else emptyCards">
  <span class="mb-2" *ngIf="cards?.length > 0">{{'gift-card.accountItemsDescription' | translate}}</span>
  <app-account-items-cards-list [cards]="cards" (itemSelected)="useItem($event)"></app-account-items-cards-list>
</ng-container>

<ng-template #emptyCards>
  <div [smooth-in]="cards" class="d-flex flex-column">
    <a [routerLink]="'/gc' | addLang : 'path'">{{'gift-card.buyNow' | translate}}</a>
  </div>
</ng-template>